import classNames from "@casino/external/classNames";
import Button from "@casino/legacyUi/Button";
import type { ComponentProps } from "react";

type Props = ComponentProps<typeof Button> & {
  isBitcasino: boolean;
};

const PrimaryButton: FC<Props> = ({ isBitcasino, className, ...props }) => (
  <Button
    className={classNames(isBitcasino && "text-background", className)}
    {...props}
  />
);

export default PrimaryButton;
